import React from 'react'

const PageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => <>
  <div className='page-title'>
    <div className='page-title__text'>
      <h1 className='title is-size-3 flex'>
        &nbsp;
        {children}
      </h1>
    </div>
  </div>
</>

export default PageTitle
